import { logAnalyticsEvent } from '@/assets/js/firebase'

export function trackRewardTaskClick ({ taskId, taskType = '', action = '' } = {}) {
  if (!taskId) return

  logAnalyticsEvent('reward_task_click', {
    task_id: String(taskId),
    task_type: taskType || '',
    action: action || ''
  })
}

export function trackRewardTaskComplete ({ taskId, position } = {}) {
  if (!taskId || !position) return

  logAnalyticsEvent('reward_task_complete', {
    task_id: String(taskId),
    position: String(position)
  })
}

export function trackRewardClaimSuccess ({ taskId, amount = 0, source = 'tap' } = {}) {
  if (!taskId) return

  logAnalyticsEvent('reward_claim_success', {
    task_id: String(taskId),
    amount: Math.max(0, Math.floor(Number(amount) || 0)),
    source: source || 'tap'
  })
}

export function trackRewardClaimFail ({ taskId, failReason = 'unknown', source = 'tap' } = {}) {
  if (!taskId) return

  logAnalyticsEvent('reward_claim_fail', {
    task_id: String(taskId),
    fail_reason: failReason || 'unknown',
    source: source || 'tap'
  })
}

export function trackRewardClaimBlockedWebview ({ taskId, taskType = '', source = 'tap' } = {}) {
  if (!taskId) return

  logAnalyticsEvent('reward_claim_blocked_webview', {
    task_id: String(taskId),
    task_type: taskType || '',
    source: source || 'tap'
  })
}
